import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'my-benefits',
  children: {
    benefits: {
      size: 'full',
      path: 'benefits',
      children: {
        perks: {
          size: 'full',
          path: 'perks',
        },
      },
    },
  },
} as const satisfies Location
